"use strict";
/**
 * Created by Marvin on 17.05.17.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var modalActions_1 = require("../actions/modalActions");
var ModalCloseButton = function (_a) {
    var hide = _a.hide;
    return (react_1["default"].createElement("button", { type: "button", className: "close", onClick: hide }, "\u00D7"));
};
var mapDispatchToProps = function (dispatch) { return ({
    hide: function () { return dispatch((0, modalActions_1.hideModal)()); }
}); };
exports["default"] = (0, react_redux_1.connect)(null, mapDispatchToProps)(ModalCloseButton);
